export default {
  state: {
    purchasable_items: []
  }
}



// WEBPACK FOOTER //
// ./src/stores/PurchasableItemsStore.js